import React, { Component } from "react";
import { connect } from "react-redux";
import PageWrapper from "../../Utilities/TemplateWrappers/PageTemplate";
import {
    getReportTypes,
    getUsers,
    setFilterUserUid,
    setCurrentTable,
} from "./actions";
import {
    selectData,
    getRequesting,
    selectRegisteredUsers,
    selectUserReportsData,
    selectFilterUserUid,
    selectCurrentTable,
    selectReportTitles,
} from "./selectors";
import styled from "styled-components";
import UserPerformanceTab from "./UserPerformanceTab";
import { hot } from "react-hot-loader";
import { Typography, Tabs, Tab } from "@material-ui/core";
import CompareTable from "./Components/CompareTable";

import { Modal, ModalBody, Spinner } from "reactstrap";

const TabsBar = styled(Tabs)`
    border: 0px solid black;
    width: fit-content;
    border-radius: 5px;
    background-color: white;
`;
class UserPerformance extends Component {
    constructor(props) {
        super(props);
        props.getUsers();
        props.getReportTypes();
    }

    render() {
        const {
            data,

            user,
            userDetails,
            selectedUser,
            setFilterUserUid,
            currentTable,
            reportTitles,
        } = this.props;
        return (
            <PageWrapper label="User Performance">
                <Modal
                    isOpen={this.props.requesting}
                    style={{ maxWidth: "00px" }}
                >
                    <ModalBody>
                        <div
                            style={{
                                textAlign: "center",
                                paddingTop: "3em",
                            }}
                        >
                            <div
                                style={{
                                    background: "white",
                                    width: "fit-content",
                                    display: "inline-block",
                                    padding: "2em",
                                }}
                            >
                                <Spinner
                                    style={{
                                        height: 100,
                                        width: 100,
                                        background: "white",
                                    }}
                                    color="primary"
                                />
                                <Typography
                                    style={{
                                        textAlign: "center",
                                        marginTop: 15,
                                        color: "rgba(0, 0, 0, 0.87)",
                                        fontWeight: "bolder",
                                        fontSize: 20,
                                    }}
                                    variant="body2"
                                >
                                    Processing...
                                </Typography>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>
                <TabsBar
                    value={currentTable}
                    onChange={(event, value) =>
                        this.props.setCurrentTable(value)
                    }
                    indicatorColor="primary"
                    textColor="primary"
                >
                    <Tab
                        value="required"
                        label={
                            <span style={{ color: "green" }}>
                                User Performance Graph
                            </span>
                        }
                    />
                    <Tab
                        value="available"
                        label={
                            <span style={{ color: "red" }}>Compare Users</span>
                        }
                    />
                </TabsBar>

                {currentTable === "required" && (
                    <UserPerformanceTab data={data} />
                )}
                {currentTable === "available" && (
                    <CompareTable
                        user={user}
                        data={data}
                        userDetails={userDetails}
                        selectedUser={selectedUser}
                        setUser={setFilterUserUid}
                        reportTitles={reportTitles}
                    />
                )}
            </PageWrapper>
        );
    }
}

export default hot(module)(
    connect(
        (store) => {
            return {
                currentTable: selectCurrentTable(store),
                data: selectData(store),

                requesting: getRequesting(store),
                user: selectRegisteredUsers(store),
                userDetails: selectUserReportsData(store),
                selectedUser: selectFilterUserUid(store),
                reportTitles: selectReportTitles(store),
            };
        },
        {
            getReportTypes,
            getUsers,

            setFilterUserUid,
            setCurrentTable,
        }
    )(UserPerformance)
);
